'use strict';

import locationLookupTemplate from './locationLookup.directive.html';

export default angular
  .module('maestro.directives.components.location-lookup', [])

  .directive('locationLookup', (
    $filter,
    $rootScope,
    $state
  ) => {
    const $t = $filter('translate');
    return {
      restrict: 'E',
      template: locationLookupTemplate,
      scope: {
        onLocationSelect: '&', // callback for location select event
        onLocationSearch: '&', // callback for search location button click
        locationsExternal: '=locations', // list of locations to display
        loading: '=', // external loading indicator
        validationRules: '@', // Array<{}>, form validation rules
        inputId: '@', // Search input id,
        scrollFix: '=', // Scroll to search results, bool
        searchHeader: '@',
        hideNotFoundMsg: '=',
        allowNewLocation: '=', // Allow creating new location
        parentId: '=',
        activeTab: '=',
      },
      controller: ($scope, $element, utils) => {

        angular.extend($scope, {
          onSearchLocationsButtonClick: onSearchLocationsButtonClick,
          onSelectLocation: onSelectLocation,
          closeHint: closeHint,
          getLocationAddress: getLocationAddress,
          inputId: $scope.inputId || 'input-location-search',
          searchHeader: $scope.searchHeader || 'locations.lookup.selectLocation',
          getLocationOrgName: getLocationOrgName,
          clearAllLocations: clearAllLocations,
          newLocation: newLocation,
        });

        const ALL_ORGS_LOCAL_STORAGE_KEY = 'Organizations-All';
        const availableOrgs = utils.getStorageItem(ALL_ORGS_LOCAL_STORAGE_KEY) || [];
        let formElement = $element.find('form')[0];

        init();

        function init() {
          $('#' + $scope.inputId).trigger('blur');
          $scope.$watch('locationsExternal', () => {
            onLocationsChange();
          });

          // Form validation options
          $scope.validationRules = $scope.validationRules || [
            {
              type: 'empty',
              prompt: $t('prompt.empty')
            }
          ];

          let options = {};
          options[$scope.inputId] = {
            rules: $scope.validationRules
          };
          $(formElement).form({
            inline: true,
            fields: options
          });
        }

        function onSearchLocationsButtonClick() {
          $(formElement).form('validate form');
          if (!$(formElement).form('is valid') || !$scope.searchStr) {
            return;
          }
          $scope.onLocationSearch({ searchTerm: $scope.searchStr, globalSearch: true });
          $scope.lastSearchStr = $scope.searchStr;
        }

        function onSelectLocation(location) {
          if (location) {
            $scope.lastSelectedLocation = location;
            $scope.onLocationSelect({ location: location });
          }
        }

        function onLocationsChange() {
          $scope.lastSelectedLocation = void 0;

          // Scroll to results
          if ($scope.scrollFix) {
            $('html, body').animate({
              scrollTop: parseInt($element.offset().top) - 100
            }, 500);
          }

          let extLocations = $scope.locationsExternal;

          if (!extLocations) {
            $scope.locations = [];
          } else if (angular.isArray(extLocations)) {
            $scope.locations = extLocations.slice(0);
          } else if (extLocations.locations && angular.isArray(extLocations.locations)) {
            $scope.locations = extLocations.locations.slice(0);
          } else {
            $scope.locations = [];
          }
        }

        function closeHint() {
          $scope.searchStr = '';
          $('#' + $scope.inputId).trigger('focus');
        }

        function clearAllLocations() {
          $scope.locations = [];
          closeHint();
        }

        function getLocationAddress(location) {
          let address = utils.generateAddress(location);
          if (!address) {
            return $t('common.unknown-address');
          }
          return address;
        }

        function getLocationOrgName(location) {
          if (!location || !location.organizationId) {
            return $t('locations.list.notAtOrg');
          }

          let org = availableOrgs.find(element => {
            return location.organizationId === element.id;
          });

          if (org && org.name) {
            return $t('locations.list.atOrg', { name: org.name });
          } else {
            return $t('common.unknownOrganization');
          }
        }

        /**
         * Redirect to create new location page,
         * with optional subType paramater
         */
        function newLocation($event) {
          $rootScope.$emit('refreshChooseMenuEvent', 'locations');
          $state.go('main.locations.new', {
            from: 'location',
            fromTab: $scope.activeTab,
            parentId: $scope.parentId || void 0,
          });
        }

      }
    };
  })

  .name;
